<template>
  <section
    class="cs-input"
    :class="{
      'cs-input_mode2': mode === 2,
      'cs-input_in-dd': inDropdown,
    }"
  >
    <label
      v-if="label && mode === 2"
      class="cs-input__label"
      :for="id"
    >
      {{ label }}
    </label>
    <label
      v-if="mode === 2"
      :for="id"
      class="cs-input__icon"
    >
      <img
        v-if="mode === 2 && !inDropdown"
        src="@/assets/img/search.svg"
        alt="search icon"
      >
      <img
        v-if="mode === 2 && inDropdown"
        src="@/assets/img/search-2.svg"
        alt="search icon"
      >
    </label>
    <div class="input-wrapper">
      <input
        :type="type"
        :placeholder="placeholder"
        :autocomplete="autocomplete"
        :readonly="autocomplete === 'off'"
        :disabled="disabled"
        :name="name"
        @focusin="toggleReadonly($event)"
        @focusout="toggleReadonly($event), clearSeach()"
        :value="value"
        class="input-wrapper__input"
        :class="{
          'cs-input__input_error': error,
          'cs-input__input_small': small,
        }"
        @input="$emit('update:value', $event.target.value)"
        @change="$emit('change', $event.target.value)"
        v-on:keyup.enter="$emit('enter')"
        @click.right="handleRightClick($event)"
        @copy="copyText($event)"
      >
      <span
        v-if="imgSource"
        @click="$emit('handle-input-icon')">
        <img
          :id="id"
          :src="imgSource"
        />
      </span>
    </div>
    <b-tooltip
      :target="id"
      class="tooltip"
      triggers="hover"
      placement="bottom"
      v-if="showTooltip"
    >
      Minimum 8 characters.
      Combination of uppercase, lowercase, alphabet, number & special characters.
    </b-tooltip>
  </section>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: 'input',
    },
    type: {
      type: String,
      default: 'text',
    },
    value: [String, Number],
    name: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    autocomplete: String,
    // mode == 2 - serach input with icon
    mode: {
      type: Number,
      default: 1,
    },
    // специальные стили для поиска в выпадающем списке
    inDropdown: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: '',
    },
    imgSource: {
      type: String,
      default: '',
    },
    showTooltip: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disabledCopy: {
      type: Boolean,
      default: false,
    },
    disabledRightClick: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    clearSeach() {
      if (this.mode === 2 && this.inDropdown) {
        this.$emit('clearSearch');
      }
    },
    // focus() {
    //   document.getElementById(this.id).focus();
    // },
    toggleReadonly(event) {
      if (this.autocomplete === 'off') {
        event.preventDefault();
        if (event.target.getAttribute('readonly') === 'readonly') {
          event.target.removeAttribute('readonly');
        } else {
          event.target.setAttribute('readonly', 'readonly');
        }
      }
    },
    copyText(e) {
      if (this.disabledCopy) {
        e.preventDefault();
      }
    },
    handleRightClick(e) {
      if (this.disabledRightClick) {
        e.preventDefault();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.cs-input {
  &__label {
    display: block;
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 6px;
  }
  .input-wrapper {
    position: relative;
    &__input {
    width: 100%;
    padding: 10px;
    color: #1B1F3B;
    font-weight: 300;
    font-size: 14px;
    display: flex;
    align-items: center;
    border-radius: 4px;
    background-color: #FFF;
    border: 1px solid #b2b7c5;
    letter-spacing: 0.04em;
    transition: 0.35s;
    &_error {
      border-color: $red600;
    }
    &_small {
      height: 52px;
    }
    &::placeholder {
      color: $black400;
      font-weight: 300;
    }
    &:hover, &:focus {
      border-color: $black500;
    }
    &:disabled {
      background-color: $black200 !important;
      border-color: $black200 !important;
      &:hover, &:focus {
        border-color: $black200 !important;
      }
    }
  }
    img {
    width: 20px;
    position: absolute;
    right: 10px;
    top: 0;
    cursor: pointer;
    height: 19px;
    bottom: 0;
    margin: auto;
    }
  }
}

.cs-input_mode2.cs-input {
  position: relative;

  & .cs-input__icon {
    position: absolute;
    width: 27px;
    min-width: 27px;
    height: 27px;
    object-fit: contain;
    display: flex;
    align-items: center;
    justify-content: center;
    left: 15px;
    bottom: 15px;
  }

  & .cs-input__input {
    padding-left: 52px;
    &::placeholder {
      color: $black400;
      font-weight: 500;
    }
  }
}

.cs-input_in-dd.cs-input {

  & .cs-input__icon {
    position: absolute;
    width: 30px;
    min-width: 30px;
    height: 30px;
    object-fit: contain;
    display: flex;
    align-items: center;
    justify-content: center;
    left: 15px;
    bottom: 7px;
  }

  & .cs-input__input {
    height: 44px;
    border-top: none;
    padding-left: 45px;
    font-weight: 400;
    font-size: 16px;
    line-height: 18px;
    &:hover, &:focus {
      border-color: $border;
    }
    &::placeholder {
      font-size: 14px;
      line-height: 16px;
      color: $grey;
      font-weight: 300;
    }
  }
  .tooltip {
    border: 1px solid #828BA1;
    background-color: #fff !important;
    color: #6E728B;
  }
}
</style>
